import Select from '@components/Select'
import { withFormsy } from 'formsy-react'

// atm react-select lib doesn't support `required` prop
// https://github.com/JedWatson/react-select/issues/3140

const RequiredSelectWithFormsy = ({
    value,
    setValue,
    onChange,
    getSelectValue,
    name,
    required = true,
    ariaLabel,
    ...props
}) => {
    const onChangeHandler = option => {
        setValue(option.value)
        onChange && onChange(option.value)
    }

    return (
        <>
            <Select {...props} value={getSelectValue(value)} onChange={onChangeHandler} aria-label={ariaLabel} />
            <input
                id={name}
                aria-label={name}
                autoComplete="off"
                className="hidden-input"
                name={name}
                value={getSelectValue(value) ? value : ''}
                required={required}
            />
        </>
    )
}

export default withFormsy(RequiredSelectWithFormsy)
